<template>
  <v-form-number
    class="c-order-entry-quantity"
    :label="label"
    :min="0"
    :max="maxValue"
    :value="value ? value : 0"
    :step="increment"
    :disabled="disabled"
    type="integer"
    @input="$emit('input', $event)"
  />
</template>

<script>
export default {
  name: 'c-order-entry-quantity',
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      required: true
    },
    maxValue: {
      default: Infinity
    },
    ticketType: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    increment() {
      if (this.ticketType === 'stock') {
        return this.$store.state.applicationSettings.orders.settings.stocks.defaultOrderIncrement;
      } else if (this.ticketType === 'option') {
        return this.$store.state.applicationSettings.orders.settings.options.defaultOrderIncrement;
      }
      return 1;
    }
  }
};
</script>

<style lang="scss">
@import '~@/styles/components/custom/c-order-entry-quantity';
</style>
